import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './LoadingOverlay.scss';

class LoadingOverlay extends Component {
  static propTypes = {
    /** Show overlay */
    showOverlay: PropTypes.bool,
  };
  static defaultProps = { showOverlay: false, };

  render() {
    const overlayClass = classNames('loading-overlay', { 'in': this.props.showOverlay, });
    return (
      <div className={overlayClass}>
        <div className={'line-spin-fade-loader'}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
}

export default LoadingOverlay;
